import { AxiosProgressEvent } from "axios";
import { axiosInstance } from "../../utils/axiosInstance";
import { getEnv } from "../../Constants/env";

export async function sendRequest(
  objectId: string,
  url: string,
  _workID: string,
  selectedRoles: any[],
  apps: any[],
  availableRoles: any[],
): Promise<any> {
  const selectedRolesNames = selectedRoles?.map(
    (item: any) => item.optionLabel,
  );
  const payload = {
    objectId: `${objectId}`,
    roles: selectedRolesNames.includes("All")
      ? availableRoles?.map((role: any) => role.optionLabel)
      : selectedRolesNames,
    application: { appId: `${apps[0].id}`, appName: apps[0].optionLabel },
  };
  const response = await axiosInstance.post(url, payload);
  return response.data;
}

export const getDataForTable = async (url: any, data: any) => {
  try {
    const response = await axiosInstance.post(url, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getPublishHistoryData = async (
  data: any,
  appId: any,
  type = "publish",
) => {
  try {
    const response = await axiosInstance.post(
      `/${type}/versions/${appId}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getUserGroupsData = async (
  data: any,
  appId: any,
  adminUserGroups = false,
) => {
  try {
    const response = await axiosInstance.post(
      `/api/groups/${adminUserGroups ? `admin/${appId}` : "superadmin"}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const reviewAndCompareVersion = async (
  appId: any,
  id: any,
  type = "publish",
) => {
  try {
    const response = await axiosInstance.get(
      `/${type}/review/${appId}${id ? `?${type === "publish" ? `versionId=${id}` : `uploadId=${id}`}` : ""}`,
      {
        headers: {
          "Accept-Encoding": "application/gzip",
        },
      },
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const downloadPublishedVersion = async (
  versionId: any,
  appId: any,
  type = "publish",
  fileType = "",
) => {
  try {
    const config: any = {
      headers: {},
    };

    if (fileType === "excel") {
      config.headers.Accept = "application/vnd.ms-excel";
      config.responseType = "blob"; // Default to 'blob' for file downloads
    }

    const response = await axiosInstance.get(
      `/${type}/download/${versionId}?${appId ? `app_id=${appId}` : ""}`,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const restoreVersion = async (data: any, versionId: any) => {
  try {
    const response = await axiosInstance.post(
      `/publish/restore/${versionId}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const uploadPolicyJSON = async (data: any, appId: any) => {
  try {
    const response = await axiosInstance.post(
      `/publish/upload?app_id=${appId}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const promotePolicyJSON = async (data: any, url: any) => {
  try {
    const response = await axiosInstance.post(url, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getAdminApprovalData = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/request/data/myapproval`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const adminApprovaDeny = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/request/action`, payload);
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const featureRestrictionApproval = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/action/approve`, payload);
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const getApplicationListApproverAdminData = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/appsetup/users?appId=${id}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const getProtectedByData = async () => {
  try {
    const response = await axiosInstance.get(`/appsetup/dropdown/protectedby`);
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const getActiveRoleDrodownData = async (appId: any) => {
  try {
    const response = await axiosInstance.get(
      `/rolesetup/dropdown/active/${appId}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getRoleSetupDrodownData = async (app_id: any) => {
  try {
    const response = await axiosInstance.get(
      `/rolesetup/dropdown/name/${app_id}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getAppAdminGroupApproverGroupDropdownData = async (appId: any) => {
  try {
    const response = await axiosInstance.get(`/appsetup/app-groups/${appId}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getApplicationDomainDropdownData = async () => {
  try {
    const response = await axiosInstance.get("/appsetup/dropdown/app_domain");
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getValueStreamDropdownData = async () => {
  try {
    const response = await axiosInstance.get("/appsetup/dropdown/value-stream");
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getDomainDropdownDataWithValueStreamDropdownData = async (
  value_stream_id: any,
) => {
  try {
    const response = await axiosInstance.get(
      `/appsetup/dropdown/value-stream?value_stream_id=${value_stream_id}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getAPIDetails = async (id: number) => {
  try {
    const response = await axiosInstance.post(
      `/featsetup/api-details?appId=${id}&page_no=1&page_size=10`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getRoleSetupTableData = async (data: any, id: any) => {
  try {
    const response = await axiosInstance.post(
      `/rolesetup/rolesbystatus?app_id=${id}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getContextTableData = async (data: any, id: any) => {
  try {
    const response = await axiosInstance.post(
      `/context/application?app_id=${id}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const featureTableData = async (data: any, appId: any) => {
  try {
    const response = await axiosInstance.post(
      `/featsetup/featurefilter?appId=${appId}`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getRoleSetupDataRestrictionDropdownData = async (id: any) => {
  try {
    const response = await axiosInstance.get(
      `/datasetup/alldomaindetails?app_id=${id}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const createDataRestriction = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/datasetup/update/domain`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteDataRestriction = async (data: any) => {
  try {
    const response = await axiosInstance.delete(`/datasetup/data-relation`, {
      data: data,
    });
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getRoleSetupFeatureDropdownData = async (appId?: number) => {
  try {
    const url = appId
      ? `/rolesetup/dropdown/feature/${appId}`
      : `/rolesetup/dropdown/feature`;
    const response = await axiosInstance.get(url);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getRoleSetupPermissionDropdownData = async (feaureId: number) => {
  try {
    const response = await axiosInstance.get(
      `/setup/dropdown/permission/${feaureId}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const applicationApprovalDenyRevoke = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/appsetup/action`, payload);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const roleSetupEditFeature = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/setup/get/feature`, payload);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const roleSetupDeleteFeature = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `/rolesetup/feature-relation`,
      payload,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getKPICardsRequestApprovaldetails = async () => {
  try {
    const response = await axiosInstance.get(`/kpi-cards/count`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getPermissionsList = async (app_id: any) => {
  try {
    const response = await axiosInstance.get(
      `/featsetup/permission/data?app_id=${app_id}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const cloneRequestApi = async (email: any, userData: any[]) => {
  try {
    const response = await axiosInstance.post(
      `/permissiondetails?user_email=${email}`,
      {
        userData,
      },
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

// Async thunk to download request template
export const downloadRequestTemplateApi = async () => {
  try {
    const response = await axiosInstance.get("/file/template", {
      headers: {
        Accept: "application/vnd.ms-excel",
      },
      responseType: "blob", // optional if you're expecting a binary file
    });
    return response;
  } catch (err) {
    return err;
  }
};

// Async thunk to download processed file
export const downloadProcessFileApi = async (payload: { fileKey: string }) => {
  try {
    const response = await axiosInstance.post("/file/download", payload, {
      headers: {
        Accept: "application/vnd.ms-excel",
      },
      responseType: "blob", // optional if you're expecting a binary file
    });
    return response;
  } catch (err) {
    return err;
  }
};

// Async thunk to upload request file
export const uploadRequestFileApi = async (
  formData: FormData,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
  type = "file",
  appId = "",
) => {
  try {
    const response = await axiosInstance.post(
      `/${type}/upload?app_id=${appId}`,
      formData,
      {
        headers: {
          Accept: "application/vnd.ms-excel",
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      },
    );
    return response.data;
  } catch (err) {
    return { ...(err || {}), error: true };
  }
};

// Async thunk to create access request Api
export const createAccessRequestApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post("/request/create", payload);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const getUserMgmtUserDetails = async (
  workID: string,
  roleID?: string,
) => {
  try {
    const response = await axiosInstance.get(
      `/user/userBasicDetails?workday_id=${workID}${roleID ? `&role_id=${roleID}` : ""}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const getFeaturesRestrictionData = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/myapproval/popup`, payload);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getEmailSearchResults = async (query: any, param: any) => {
  try {
    const response = await axiosInstance.get(
      `/appsetup/emails?${param}=${query}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getAzureApplicationSearchResults = async (searchTerm: string) => {
  try {
    const env = (getEnv()?.envtype || "dev").toUpperCase();
    const response = await axiosInstance.get(
      `/appsetup/search-azure-apps?searchTerm=${encodeURIComponent(searchTerm)}&env=${env}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getValueStreamsData = async () => {
  try {
    const response = await axiosInstance.get(
      `/valuestream/getValueStreamsData`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};
export const createValueStream = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/valuestream/create`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteValueStream = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `/valuestream/delete-or-unmap`,
      payload,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const createContext = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/context/create`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const editContext = async (data: any) => {
  try {
    const response = await axiosInstance.put(`/context/update`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteContext = async (id: any) => {
  try {
    const response = await axiosInstance.delete(
      `/context/delete?context_id=${id}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getUnmappedApplicationStream = async () => {
  try {
    const response = await axiosInstance.get(
      `/valuestream/unmapped-applications`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteApplication = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `/valuestream/delete-or-unmap`,
      payload,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getDetailsValueStream = async (id: any) => {
  try {
    const response = await axiosInstance.get(
      `/valuestream/get-value-stream-by-id?value_stream_id=${id}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const updateValueStream = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/valuestream/edit`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const addApplication = async (data: any) => {
  try {
    const response = await axiosInstance.put(
      `/valuestream/map-application`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getPermissionList = async (app_id: any) => {
  try {
    const response = await axiosInstance.get(
      `/perms/app-perms?app_id=${app_id}`,
    );
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const getPermissionIdList = async () => {
  try {
    const response = await axiosInstance.get(`perms/dropdown`);
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const reorderPermissionList = async (formData: any) => {
  try {
    const response = await axiosInstance.post(`perms/reorder`, formData);
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const setPermissionStatus = async (formData: any) => {
  try {
    const response = await axiosInstance.post(`perms/update-status`, formData);
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const deletePermission = async (formData: any) => {
  try {
    const response = await axiosInstance.post(`perms/delete`, formData);
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const exportApplication = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/onboard/app`, data, {
      headers: {
        Accept: "application/vnd.ms-excel",
      },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadApplication = async (id: any) => {
  try {
    const response = await axiosInstance.get(`/promote/export/${id}`, {
      headers: {
        Accept: "application/vnd.ms-excel",
      },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadApplicationTemplate = async () => {
  try {
    const response = await axiosInstance.get(`onboard/template`, {
      headers: {
        Accept: "application/vnd.ms-excel",
      },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRoleDetailsByRoleId = async (roleId: any) => {
  try {
    const response = await axiosInstance.get(`/rolesetup/role/${roleId}`);
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const getRoleContextDetails = async (appId: any) => {
  try {
    const response = await axiosInstance.get(`/rolesetup/context/${appId}`);
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const getGroupsWithFeatures = async () => {
  try {
    const response = await axiosInstance.get("/featgroup/groupswithfeatures");
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const createFeatureGroup = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/featgroup/create`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const editFeatureGroup = async (data: any) => {
  try {
    const response = await axiosInstance.put(`/featgroup/edit`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getFeatureGroupById = async (groupId: any) => {
  try {
    const response = await axiosInstance.get(
      `/featgroup/group?group_id=${groupId}`,
    );
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const deleteFeatureGroup = async (payload: { group_id: number }) => {
  try {
    const response = await axiosInstance.delete("/featgroup/delete", {
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return response.data;
  } catch (error: any) {
    return {
      error: true,
      message: error?.response?.data || error?.message,
    };
  }
};

export const getFeaturesByGroupId = async (groupId: any) => {
  try {
    const response = await axiosInstance.get(
      `/featgroup/group/features?group_id=${groupId}`,
    );
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const getApplicationsWithFeatures = async () => {
  try {
    const response = await axiosInstance.get("/featgroup/app/features");
    return response?.data;
  } catch (error) {
    return { ...(error || {}), error: true };
  }
};

export const mapFeatureToGroup = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/featgroup/feature/map`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const featureGroupVisibilityToggle = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/featgroup/visibility`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const featureGroupsReorder = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/featgroup/reorder`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const featureGroupFeaturesReorder = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/featgroup/features/reorder`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteFeatureInFeatureGroup = async (payload: {
  group_id: number;
  feature_id: number;
}) => {
  try {
    const response = await axiosInstance.delete("/featgroup/feature/unmap", {
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return response.data;
  } catch (error: any) {
    return {
      error: true,
      message: error?.response?.data || error?.message,
    };
  }
};

export const featureGroupFeatureVisibilityToggle = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/featgroup/feature/visibility`,
      data,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const createDomain = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/datasetup/domain`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const editDomain = async (data: any) => {
  try {
    const response = await axiosInstance.put(`/datasetup/domain`, data);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteDomain = async (id: any) => {
  try {
    const response = await axiosInstance.delete(`/datasetup/domain`, {
      data: {
        domainId: id,
      },
    });
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getCubeAuthVersionList = async (appId?: any, payload?: any) => {
  try {
    const requestBody: {
      appId?: string;
      sortingFilter: {
        filter: any[];
        sort: any[];
        page: {
          limit: number;
          offset: number;
        };
      };
    } = {
      sortingFilter: payload?.sortingFilter ?? {
        filter: [],
        sort: [],
        page: {
          limit: 25,
          offset: 0,
        },
      },
    };

    if (appId !== undefined && appId !== null && appId !== "") {
      requestBody.appId = String(appId);
    }

    const response = await axiosInstance.post(
      `/onboard/lib-versions`,
      requestBody,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getCubeAuthCurrentVersion = async (appId: any) => {
  try {
    const response = await axiosInstance.get(`/app/cube-auth/current/${appId}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const publishCubeAuthVersion = async (appId: any, versionId: any) => {
  try {
    const response = await axiosInstance.post(
      `/app/cube-auth/publish/${appId}`,
      { versionId },
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const registerCubeAuthVersion = async (
  version: string,
  appId?: number,
  customPayload?: {
    version: string;
    appId?: number;
    edit?: boolean;
    id?: number;
  },
) => {
  try {
    const env = (getEnv()?.envtype || "dev").toUpperCase();
    const body: {
      version: string;
      appId?: number;
      edit?: boolean;
      id?: number;
    } = customPayload || { version };

    if (!customPayload && typeof appId === "number") {
      body.appId = appId;
    }

    const response = await axiosInstance.post(
      `/onboard/lib-versions/register?env=${env}`,
      body,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};
